"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("./state"));
const mutations = {
    setCurrentRoute: (name, props = {}) => {
        state_1.default.router.current = name;
        state_1.default.router.props = props;
    },
    setOriginPortal: (portalType) => {
        state_1.default.portalType = portalType;
    },
    setPreferredPortal: (portalType) => {
        state_1.default.preferredPortalType = portalType;
    },
    setUserName: (name) => {
        state_1.default.userName = name;
    },
    answerQuestion: (answerObject) => {
        state_1.default.questions[answerObject.id].answer = answerObject.answer;
    },
    setLoggedInFlag: (isLoggedIn) => {
        state_1.default.isLoggedIn = isLoggedIn;
    },
    storeResults: (results) => {
        state_1.default.results = results;
    }
};
exports.default = mutations;
